import { createFileRoute } from '@tanstack/react-router';

import { ProductsPage, validateProductsSearch } from '../../features/products';

export const Route = createFileRoute('/_app/goods')({
  staticData: { crumbs: ['Справочник товара'] },
  // Фильтры, сортировка и страница живут в адресной строке - валидируем их здесь.
  validateSearch: validateProductsSearch,
  component: ProductsPage,
});
